const isPWA = () => window.matchMedia("(display-mode: standalone)").matches;
export default isPWA();